import Button from '@mui/material/Button';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
  wider: {
    paddingLeft: '2.75rem',
    paddingRight: '2.75rem',
  },
  buttonsWrapper: {
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    padding: '10px 20px',
    borderTop: 'solid rgba(0, 0, 0, 0.12) thin',
  },
  loader: {
    color: theme.palette.baseColors.white.c100,
  },
}));

const getButtonLabels = (variant) => {
  switch (variant) {
    default:
    case 'apply':
      return {
        primaryActionText: 'Apply',
        secondaryActionText: 'Clear',
      };
    case 'submit':
      return {
        primaryActionText: 'Submit',
        secondaryActionText: 'Cancel',
      };
  }
};

export const CloseButtons = ({ primaryAction, secondaryAction, variant = 'apply' }) => {
  const classes = useStyles();

  const { primaryActionText, secondaryActionText } = getButtonLabels(variant);

  return (
    <div className={classes.buttonsWrapper}>
      <div className={classes.buttonsContainer}>
        {!!secondaryAction && (
          <Button variant="contained" onClick={secondaryAction.onClick}>
            {secondaryActionText}
          </Button>
        )}
        <Button
          variant="contained"
          color="secondary"
          className={classes.wider}
          onClick={primaryAction.onClick}
          disabled={primaryAction.disabled || primaryAction.loading}
        >
          {primaryAction.loading ? (
            <CircularProgress size={24} className={classes.loader} />
          ) : (
            primaryActionText
          )}
        </Button>
      </div>
    </div>
  );
};
